import type { Permission } from './permissions';

export type CommandPaletteAction = {
  id: string;
  label: string;
  keywords?: string[];
  href?: string;
  action?: string;
  requiredPermissions?: Permission[];
  group: 'actions' | 'navigation';
};

export const COMMAND_PALETTE_ACTIONS: CommandPaletteAction[] = [
  {
    id: 'run-validation',
    label: 'Run validation',
    keywords: ['validate', 'check', 'test'],
    href: '/validation',
    action: 'run-validation',
    requiredPermissions: ['validation:run'],
    group: 'actions',
  },
  {
    id: 'sync-agents',
    label: 'Sync Salesforce Agents',
    keywords: ['agents', 'salesforce', 'sync', 'import'],
    href: '/salesforce',
    action: 'sync-agents',
    requiredPermissions: ['agents:sync'],
    group: 'actions',
  },
  {
    id: 'add-salesforce-org',
    label: 'Add Salesforce Org',
    keywords: ['salesforce', 'org', 'connect'],
    href: '/salesforce',
    action: 'add-salesforce-org',
    requiredPermissions: ['salesforce:edit'],
    group: 'actions',
  },
  {
    id: 'add-connection',
    label: 'Create Connection',
    keywords: ['twilio', 'connect', 'telephony', 'provider'],
    href: '/telephony',
    action: 'add-connection',
    requiredPermissions: ['telephony:edit'],
    group: 'actions',
  },
  {
    id: 'go-setup',
    label: 'Go to Setup',
    keywords: ['onboarding', 'wizard', 'setup', 'configure'],
    href: '/configure',
    requiredPermissions: ['setup:edit', 'dashboard:view'],
    group: 'actions',
  },
  {
    id: 'go-dashboard',
    label: 'Go to Dashboard',
    href: '/dashboard',
    requiredPermissions: ['dashboard:view'],
    group: 'navigation',
  },
  {
    id: 'go-validation',
    label: 'Go to Validation',
    href: '/validation',
    requiredPermissions: ['validation:view'],
    group: 'navigation',
  },
  {
    id: 'go-agents',
    label: 'Go to Agents',
    href: '/users',
    requiredPermissions: ['users:view'],
    group: 'navigation',
  },
  {
    id: 'go-audit',
    label: 'Go to Audit Log',
    href: '/audit',
    requiredPermissions: ['audit:view'],
    group: 'navigation',
  },
];

/** localStorage key for recent command palette resources */
export const COMMAND_PALETTE_RECENT_KEY = 'voicera:command-palette:recent';

/** localStorage key for pinned favorites */
export const COMMAND_PALETTE_FAVORITES_KEY = 'voicera:command-palette:favorites';

export const COMMAND_PALETTE_MAX_RECENT = 10;
